'use client';

import SubmitExperienceBanner from 'iq-interview_experiences/components/submit_experience_banner';
import SubscribePremiumBanner from 'iq-upselling/components/subscribe_premium_banner';
import {useAuth} from 'iq-auth';
import {InterviewGuideData} from 'iq-interview_guides/types';

export default function SidebarBanner({data}: {data: InterviewGuideData}) {
  const {isPremium} = useAuth();

  if (data.experience_shared && !isPremium) {
    return <SubscribePremiumBanner />;
  }
  return <SubmitExperienceBanner data={data} />;
}
